<script setup lang="ts">
import { type StepDeliveryEditPageContentStepDeliveryPayloadFragment } from './StepDeliveryEditPageContent.generated'
import { computed } from 'vue'
import StepDeliveryForm from '@/components/organisms/StepDeliveryForm/StepDeliveryForm.vue'
import type { StepDeliveryFormType } from '@/components/organisms/StepDeliveryForm/formSchema'

const props = defineProps<{
  payload: StepDeliveryEditPageContentStepDeliveryPayloadFragment
}>()

const initialForm = computed(() => {
  return {
    guid: props.payload.guid,
    name: props.payload.name,
    startAt: props.payload.startAt ? new Date(props.payload.startAt) : null,
    endAt: props.payload.endAt ? new Date(props.payload.endAt) : null,
    cond: props.payload.cond,
    addFriendDate: props.payload.addFriendDate
      ? new Date(props.payload.addFriendDate)
      : null,
    IsDisabled: props.payload.IsDisabled,
    steps: props.payload.steps.map(step => ({
      guid: step.guid,
      targetDayAfter: step.targetDayAfter,
      targetHour: step.targetHour,
      message: step.message,
      answerSelections: step.answerSelections
        ? step.answerSelections.map(selection => ({
            guid: selection.guid,
            selection: selection.selection,
          }))
        : [],
    })),
  } as StepDeliveryFormType
})
</script>

<template>
  <div>
    <h1>ステップ配信 詳細ページ</h1>
    <StepDeliveryForm
      :initialForm="initialForm"
      @submit="$emit('submit', $event)"
      :class="$style.form"
    />
  </div>
</template>

<style module lang="scss">
.form {
  margin-top: 16px;
}
</style>
